import React from 'react';
import './WhyUs.css';

const WhyUs = () => (
  <section id="why">
    <div className="section-hero">
      <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/robot-dog-safety-shero-2560x1440.jpeg')` }}></div>
      <div className="prlx-overlay"></div>
      <div className="prlx-overlay-gold"></div>
      <div className="sh-content">
        <div className="sh-label">Our Commitment</div>
        <h2 className="sh-title">Why Choose <em>Profibercom</em></h2>
      </div>
    </div>

    <div className="sec why-sec">
      <div className="sec-inner">
        <div className="centered reveal">
          <div className="sec-label">Why Choose Profibercom</div>
          <h2 className="sec-title">Our Commitment to <em>Excellence</em></h2>
          <div className="divider"></div>
        </div>
        <div className="why-grid stagger-children">
          <div className="why-card reveal"><div className="why-ico">🛡️</div><h3>Zero-Harm Philosophy</h3><p>Fail-safes and non-contact operations to protect personnel.</p></div>
          <div className="why-card reveal"><div className="why-ico">📡</div><h3>EMI-Proof Connectivity</h3><p>Fiber optic systems engineered for harsh, noisy environments.</p></div>
          <div className="why-card reveal"><div className="why-ico">🔩</div><h3>IP66-Rated Durability</h3><p>Components built to withstand extreme site conditions.</p></div>
        </div>
      </div>
    </div>

    <div className="cta-banner">
      <div className="inner reveal">
        <h2>Ready to Enhance Your Site's Safety & Connectivity?</h2>
        <p>Partner with Profibercom for unparalleled expertise in Control, Instrumentation, and Communication Systems.</p>
        <a href="#contact" className="btn-dark">Start a Project With Us →</a>
      </div>
    </div>
  </section>
);

export default WhyUs;